<script lang="ts" setup>
import type { Group } from '~/models/Group'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import useGroupsStore from '~/stores/groups'
import Select from '~/components/ui/Select.vue'

const { t } = useI18n()
const { sortedGroups } = storeToRefs(useGroupsStore())

const model = defineModel<Group>()
</script>

<template>
  <label class="flex flex-col gap-2">
    <span
      class="text-base font-medium"
      v-text="t('assign.placeholders.chooseGroup')"
    />
    <Select
      v-model="model"
      :option-label="(group: Group) => group.name"
      :options="sortedGroups"
      :placeholder="t('assign.placeholders.chooseGroup')"
      size="lg"
      variant="outline"
    />
  </label>
</template>
